import { useState } from 'react';
import { END_DATE_ERROR, INVALID_CONTRACT_END_DATE, INVALID_CONTRACT_START_DATE, INVALID_DATE_FORMAT_ERROR, ITEM_ERROR, MIN_AMOUNT_ERROR, MIN_QUANTITY_ERROR, MIN_RATE_ERROR, QUANTITY_ERROR, RATE_ERROR, START_DATE_ERROR, UPLOAD_DOCUMENT_ERROR, UPLOAD_MAX_FILE_ERROR, UPLOAD_MAX_SIZE_ERROR, UPLOAD_PDF_ERROR, VALID_FORMAT_ERROR, VENDOR_ERROR } from '../utils/helpers/globalErrorMessage';

const AddContractValidation = () => {
    const [errors, setErrors] = useState({});

    const isValidFileType = (file) => {
        const allowedTypes = ["application/pdf"];
        return allowedTypes.includes(file.type);
    };

    const MAX_FILE_SIZE = 2 * 1024 * 1024;

    const isValidDateFormat = (dateStr) => {
        const regex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
        return regex.test(dateStr);
    };
    
    const parseDate = (dateStr) => {
        return new Date(dateStr);
    };
    

    const validateForm = (vendorId, startDate, endDate, itemDescription, contractTotal, contractDocument) => {

        let errors = {};
        errors.itemDescription = []
        let formIsValid = true;

        if (!vendorId) {
            formIsValid = false;
            errors.vendorId = VENDOR_ERROR
        }

        const noOfDaysfromCurrentDate = (startDate) => {
            const modifiedStartDate = new Date(startDate);
            const currentDate = new Date();
            const timeDifference = currentDate - modifiedStartDate;
            const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
            return daysDifference;
        };

        if (!startDate) {
            formIsValid = false;
            errors.startDate = START_DATE_ERROR;
        } else if (!isValidDateFormat(startDate)) {
            formIsValid = false;
            errors.startDate = VALID_FORMAT_ERROR;
        } else {
            const daysOld = noOfDaysfromCurrentDate(startDate);
            if (daysOld > 90) {
                formIsValid = false;
                errors.startDate = INVALID_CONTRACT_START_DATE;
            }
        }

        if (!endDate) {
            formIsValid = false;
            errors.endDate = END_DATE_ERROR;
        } else if (!isValidDateFormat(endDate)) {
            formIsValid = false;
            errors.endDate = VALID_FORMAT_ERROR;
        } else if (startDate && isValidDateFormat(startDate)) {
            const startDateObj = parseDate(startDate);
            const endDateObj = parseDate(endDate);
            if (endDateObj <= startDateObj) {
                formIsValid = false;
                errors.endDate = INVALID_CONTRACT_END_DATE;
            }
        }

        if (contractTotal === "0.00") {
            formIsValid = false;
            errors.contractTotal = MIN_AMOUNT_ERROR
        }
        if (!contractDocument || contractDocument.length === 0) {
            formIsValid = false;
            errors.files = UPLOAD_DOCUMENT_ERROR
        }
        // else if (!formState.files || formState.files.length === 0) {
        //     formIsValid = false;
        //     errors.files = "Please attach a file !";
        // }
        else if (contractDocument) {
            for (const file of contractDocument) {
                if (!isValidFileType(file)) {
                    formIsValid = false;
                    errors.files = UPLOAD_PDF_ERROR
                    break;
                }
                if (file.size > MAX_FILE_SIZE) {
                    formIsValid = false;
                    errors.files = UPLOAD_MAX_SIZE_ERROR
                    break;
                }
                if (contractDocument.length > 5) {
                    formIsValid = false;
                    errors.files = UPLOAD_MAX_FILE_ERROR
                    break;
                }
            }
        }
        itemDescription.forEach((item, index) => {
            const lineItemErrors = {};

            if (!item.itemId) {
                formIsValid = false;
                lineItemErrors.itemId = ITEM_ERROR
            }
            if (!item.rate) {
                formIsValid = false;
                lineItemErrors.rate = RATE_ERROR
            }
            if (item.rate && item.rate == 0) {
                formIsValid = false;
                lineItemErrors.rate = MIN_RATE_ERROR;
            }
            if (!item.quantity) {
                formIsValid = false;
                lineItemErrors.quantity = QUANTITY_ERROR;
            }
            if (item.quantity && item.quantity == 0) {
                formIsValid = false;
                lineItemErrors.quantity = MIN_QUANTITY_ERROR;
            }
            if (Object.keys(lineItemErrors).length > 0) {
                errors.itemDescription[index] = lineItemErrors;
            }
            return lineItemErrors;
        });

        if (errors.itemDescription.length === 0) {
            delete errors.itemDescription;
        }

        setErrors(errors);
        return formIsValid;
    };

    return { errors, setErrors, validateForm };
};

export default AddContractValidation;